import axiosReadInstance from '@request/axiosReadInstance'
import { API_URL } from '@constants'

export const fetchCities = async () => {
    return axiosReadInstance.get(`${API_URL}/api/cities`)
}
